<template>
  <div>
    <ModalMotivoSolicitud
      ref="modalMotivoSolicitud"
      v-on:cerrar="modalMotivoCerrado($event)"
    />
    <Modal ref="modal" :grande="modalGrande">
      <template slot="cabecera">
        <h5 class="modal-title">
          <slot name="modalTitulo"></slot>
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </template>
      <template slot="cuerpo">
        <slot name="modalCuerpo" v-bind:item="item"></slot>
      </template>
      <template v-slot:pie>
        <template v-if="item">
          <button @click="aprobar()" type="button" class="btn btn-success">
            <font-awesome-icon :icon="Icons.ACEPTAR" />
            Aprobar
          </button>
          <button @click="rechazar()" type="button" class="btn btn-danger">
            <font-awesome-icon :icon="Icons.RECHAZAR" />
            Rechazar
          </button>
        </template>
      </template>
    </Modal>

    <Tabla
      ref="tabla"
      :busqueda="busqueda"
      :cargaManual="cargaManual"
      :columnas="columnas"
      :facade="facade"
      v-on:evento-item-elegido="abrir($event)"
    ></Tabla>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";

import { Icons as IconConstants } from "../../../constants";
import Modal from "../modals/Modal.vue";
import Tabla from "../tablas/Tabla.vue";
import { Util } from "../../../util";
import ModalMotivoSolicitud from "../../panel/modals/ModalMotivoSolicitud.vue";
import { SolicitudComercioFacade as Facade } from "../../../service/admin/solicitud-comercio/solicitud-comercio.facade";


const EVENTO_APROBADO = "aprobado";

export default {
  components: {
    FontAwesomeIcon,
    ModalMotivoSolicitud,
    Modal,
    Tabla
  },
  props: {
    busqueda: Object,
    // Si está en verdadero, no se realizarán cargas automáticas
    // Ejemplo en el mounted hook o cuando cambia la búsqueda
    cargaManual: Boolean,
    /** Columnas de la tabla */
    columnas: Array,
    /** Usado para cargar y guardar información (aprobar y rechazar en este caso) */
    facade: Function,
    /** En caso de ser verdadero, se mostrará un modal grande */
    modalGrande: Boolean
  },
  data() {
    return {
      item: undefined,
      solicitudParaRechazar: {},
    };
  },
  computed: {
    /** Constantes de iconos */
    Icons() {
      return IconConstants;
    }
  },
  methods: {
    abrir(item) {
      this.item = Util.copiaProfunda(item);
      this.$refs.modal.abrir();
    },
    aprobar() {
      Swal.fire({
        title: "¿Estás seguro?",
        icon: "question",
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "rgb(125 133 140)",
        confirmButtonText: "Si, aprobar",
        cancelButtonText: "Cancelar",
        keydownListenerCapture: true,
        preConfirm: () => {
          return this.facade
            .approve(this.item)
            .then(() => {
              this.$refs.tabla.eliminado(this.item);
              this.$emit(EVENTO_APROBADO, this.item);
            })
            .catch(() => {
              Swal.showValidationMessage("Ocurrió un error al aprobar");
            });
        }
      }).then(result => {
        // Si confirma
        if (result.isConfirmed) {
          Swal.fire({ title: "Aprobado!", icon: "success" });
          this.cerrar();
        }
      });
    },
    cerrar() {
      this.$refs.modal.cerrar();
    },
    /** Evento proxy para pasar a las tablas */
    recargar() {      
      this.$refs.tabla.recargar();
    },    
    rechazar() {
      this.solicitudParaRechazar = this.item;
      Swal.fire({
        title: "¿Estás seguro?",
        icon: "question",
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "rgb(125 133 140)",
        confirmButtonText: "Si, rechazar",
        cancelButtonText: "Cancelar",
        keydownListenerCapture: true,
        preConfirm: () => {
         }
      }).then(result => {
        // Si confirma
        if (result.isConfirmed) {          
          this.$refs.modalMotivoSolicitud.EventoAbrir();
          this.cerrar();
        }
      });
    },
    modalMotivoCerrado(motivoRechazo) {
      this.solicitudParaRechazar.motivoRechazo = motivoRechazo;
          Facade.reject(this.solicitudParaRechazar)
            .then(() => {              
              Swal.fire(
                "Confirmación",
                "La solicitud ha sido rechazada",
                "success"
              );
              this.recargar();
            })
    },
  }
};
</script>
